module.exports = __webpack_public_path__ + "img/chain11.c6b88b79.png";